import React from 'react'
import { Horizontal, onExport } from '@gravitate-js/excalibrr'
import { DateRangeFilter } from '@/components/_SiteWide/DateRangeFilter'
import { UploadDownloadButtons } from '@components/_SiteWide/UploadStatus/UploadDownloadButtons'

export const ActionButtons = ({
  filters,
  setFilters,
  gridAPIRef,
  getDatesFromStorage,
  siteBolsDayRange,
  setSiteBolsDayRange,
  storageKey,
}) => {
  const excelOptions = [
    {
      title: 'Site BOLs Report',
      onClick: () =>
        onExport(gridAPIRef, {
          fileName: `SiteBOLsReport.xlsx`,
          sheetName: 'Site BOLs Report',
          columnKeys: [
            'order_number',
            'po',
            'bol_number',
            'bol_terminal',
            'bol_supplier',
            'bol_product',
            'bol_date',
            'bol_contract',
            'bol_net_volume_original',
            'bol_gross_volume_original',
            'bol_net_volume_allocated',
            'bol_gross_volume_allocated',
            'hauled_by',
            'tractor',
            'trailer',
            'site',
            'delivery_product',
            'tank_id',
            'delivery_date',
            'delivery_time',
            'delivery_volume',
          ],
        }),
    },
  ]

  return (
    <Horizontal gap={16} alignItems={'center'}>
      <UploadDownloadButtons excelOptions={excelOptions} />
      <DateRangeFilter
        currentFilters={filters}
        setCurrentFilters={setFilters}
        getFromStorage={getDatesFromStorage}
        storageKey={storageKey}
        dayRangeStorage={siteBolsDayRange}
        setDayRangeStorage={setSiteBolsDayRange}
      />
    </Horizontal>
  )
}
